import palettes from '../../theme/palettes';
import { createUseStyles } from '../../theme/theming';

const useSectionStyles = createUseStyles((theme) => ({
  section: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: ({ isMobile } = {}) =>
      isMobile
        ? `${theme.spacing.padding.regular}px ${theme.spacing.padding.small}px`
        : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
    background: `linear-gradient(180deg, ${theme?.colors?.background2} 50%, #FFFFFF 50%)`,

    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    }
    // '& h2,& h3': {
    //   fontWeight: '500',
    //   '& b,& strong': {
    //     fontWeight: '700'
    //   }
    // }
  },
  contactContainer: {
    width: '100%',
    margin: '0 auto',
    maxWidth: ({ containerWidth } = {}) => containerWidth
  },
  sectionContainer: {
    backgroundColor: theme?.colors?.white,
    boxShadow: theme?.shadows?.secondary,
    borderRadius: theme?.shape?.borderRadius?.regular,
    padding: '48px',
    position: 'relative'
  },
  title: {
    margin: '0',
    fontSize: theme.typography.fontSize.h2,
    color: theme?.colors?.lightblack?.default,
    lineHeight: '71px',
    letterSpacing: '-3px',
    textAlign: 'left',
    wordBreak: 'break-word',
    textAlign: 'center'
  },

  contentContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    wordBreak: 'break-word',
    gap: '56px'
  },
  leftContainer: {
    display: 'flex',
    // flexDirection: 'column',
    flex: 1
    // justifyContent: 'space-between',
    // flex: 1
  },
  subtitle: {
    // margin: '0 0 auto 0',
    fontSize: theme.typography.fontSize.h6,
    color: theme?.colors?.lightblack,
    // lineHeight: '32px',
    // margin: '16px 0',
    textAlign: 'center',
    marginBottom: '32px'
  },
  addressContainerContact: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    width: '100%',
    position: 'relative'
  },
  telephoneImage: {
    width: '100%'
  },
  rightContainer: {
    flex: 1,
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  inputDiv: {
    margin: '0 0 20px 0',
    position: 'relative',
    display: 'flex'
  },
  inputField: {
    width: '100%',
    // maxWidth: '314px',
    // background: theme?.palette?.background?.default,
    border: `1px solid ${theme?.colors?.cta}`,
    borderRadius: theme?.shape?.borderRadius?.regular,
    // padding: '14px 12px',
    display: 'flex',
    fontWeight: '400',
    fontSize: theme.typography.fontSize.subHead,
    lineHeight: '20px',
    fontFamily: 'inherit',
    resize: 'none',
    '&::placeholder': {
      fontWeight: '400',
      fontSize: theme.typography.fontSize.subHead,
      lineHeight: '20px',
      color: theme?.colors?.lightblack,
      fontFamily: theme?.typography?.fontFamily
    },
    '&:focus': {
      outline: 'none'
    }
  },
  error: {
    borderBottom: '1px solid red',
    position: 'absolute',
    bottom: '-8px',
    width: 'calc(100% - 24px)'
  },

  errorBorder: {
    border: `1px solid red`,
    color: 'red',
    '&::placeholder': {
      color: 'red',
      opacity: '0.5'
    }
  },
  btnContainer: {},

  '@media screen and (max-width: 767px)': {
    section: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    sectionContainer: {
      padding: '16px'
    },
    partialBackground: {
      height: '150px'
    },
    contentContainer: {
      flexDirection: 'column',
      // marginTop: '8px'
      gap: '8px'
    },
    leftContainer: {
      width: '100%',
      marginBottom: '16px'
    },
    rightContainer: {
      width: '100%',
      padding: '0'
    },
    title: {
      lineHeight: '26px',
      letterSpacing: 'initial',
      textAlign: 'center'
    },
    subtitle: {
      // margin: '4px 0 24px 0',
      marginTop: '16px',
      textAlign: 'center',
      fontSize: '14px',
      lineHeight: '20px',
      marginBottom: '32px'
    },
    addressRow: {
      // padding: '12px 0'
    },
    addressContainerContact: {
      height: '280px',
      marginBottom: '16px',
      '& img': {
        width: '100%'
      }
    },
    inputDiv: {
      // margin: '0 0 10px 0'
    },
    inputField: {
      width: '100%',
      maxWidth: 'unset'
    },
    error: {
      bottom: '-2px'
    },
    contactContainer: {
      width: '97%'
    },
    btnContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }
}));

export default useSectionStyles;
